import { useState } from "react";

import { Button, ModalDelete } from "expano-components";

import { Main, PageLoader, Error } from "components";
import useGet from "hooks/useGet";
import useDelete from "hooks/useDelete";

import { ReactComponent as ProductIcon } from "icons/product.svg";

import BasicData from "./components/BasicData";
import BrandChannels from "./components/BrandChannels";

const BrandEdit = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const [show_delete_modal, setShowDeleteModal] = useState(false);

  const {
    is_loading,
    is_error,
    error,
    data: brand,
    refetch,
  } = useGet({
    query: ["brand", id],
    path: `/brands/${id}`,
    context: "ui_show",
  });

  const { is_deleting, _delete } = useDelete({
    path: `/brands/${id}`,
    onSuccess: () => history.push("/brands"),
  });

  if (is_loading) {
    return <PageLoader />;
  }

  if (is_error) {
    return <Error message={error} />;
  }

  return (
    <Main
      page={{
        name: brand?.name,
        icon: <ProductIcon />,
        breadcrumbs: [
          {
            name: "Marki",
            path: "/brands",
          },
          { name: brand?.name },
        ],
        buttons: (
          <Button
            type="delete"
            text="Usuń markę"
            disabled={is_deleting}
            onClick={() => setShowDeleteModal(true)}
          />
        ),
      }}
    >
      {show_delete_modal && (
        <ModalDelete
          handleDelete={_delete}
          handleClose={() => setShowDeleteModal(false)}
          name={`markę ${brand?.name}?`}
        />
      )}
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <BasicData
            brand_id={id}
            refetch={refetch}
            initialValues={{
              name: brand?.name,
              email: brand?.email,
              producer_id: brand?.producer?.id,
            }}
          />
        </div>
        <div className="column-half">
          <BrandChannels
            brand_id={id}
            data={brand?.brand_channels}
            refetch={refetch}
          />
        </div>
      </div>
    </Main>
  );
};

export default BrandEdit;
